import { CheckCircle, Laugh, Users, Brain, Building2, MessageSquare, Star } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

const benefits = [
  { title: "Integracja zespołu", description: "Wspólny śmiech zbliża ludzi i buduje silniejsze relacje w zespole", icon: Users },
  { title: "Redukcja stresu", description: "Humor to najlepszy sposób na rozładowanie napięcia w pracy", icon: Brain },
  { title: "Pozytywny wizerunek", description: "Pokazujesz, że Twoja firma dba o dobrą atmosferę i zadowolenie pracowników", icon: Building2 },
  { title: "Wzrost produktywności", description: "Zrelaksowani pracownicy są bardziej efektywni i kreatywni", icon: Star },
  { title: "Lepsza komunikacja", description: "Humor pomaga przełamać bariery i ułatwia komunikację w zespole", icon: MessageSquare },
  { title: "Niezapomniane wspomnienia", description: "Tworzymy momenty, które na długo pozostaną w pamięci pracowników", icon: Laugh },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-24 md:py-32 bg-white">
      <div className="container">
        <ScrollReveal>
          <h2 className="section-heading">
            Dlaczego <span className="gradient-text">warto</span>?
          </h2>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return (
              <ScrollReveal key={benefit.title} delay={i * 0.08}>
                <div className="modern-card text-center group h-full">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-brand-purple/10 to-brand-magenta/10 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-brand-purple" />
                  </div>
                  <h3 className="text-lg font-montserrat font-bold mb-3 text-primary">{benefit.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{benefit.description}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
